import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';
import { setDistrictsArray } from '_helpers';
import {
  zone as zoneSetup,
  config as configSetup
} from '_actions';

import { getCampaignActiveStatus as campaignStatus } from '../../../Campaign/redux/actions';

const Container = styled.div`
  padding: 30px 20px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items:center;
  width:100%;
  background-color: #f9f9f9;
  margin-bottom: 15px;
  box-sizing: border-box;

  label {
    display: none !important;
  }
`;

const Text = styled.h3`
  font-size: 16px !important;
   
  text-align: center;
  font-weight: 400 !important;
`;

const DataList = styled.datalist``;

const Option = styled.option`
  font-size: 14px !important;
  text-align: left !important;
  font-weight: normal !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
`;

const Input = styled.input`
  height: 47px !important;
  font-size: 14px !important;
  min-width: 300px !important;
  text-align: left !important;
  border-radius: 6px !important;
  font-weight: normal !important;
  white-space: nowrap !important;
  background-color: #fff !important;
  text-overflow: ellipsis !important;
  border: 1.5px solid #A0A0A0 !important;
`;

const MultiDistrict = ({
  districts,
  projectId,
  setZoneStr,
  rawDistricts,
  webappConfig,
  districtLabel,
  setDistrictLabel,
  getCampaignActiveStatus,
  shouldSeeDistrictSelector,
}) => {
  const history = useHistory();
  const {
    has_wgw: hasWgw, has_calendar: hasCalendar
  } = webappConfig || {
    has_wgw: false, has_calendar: false
  };

  const options = districts
    .sort((a, b) => {
      if (a.district_nm < b.district_nm) return -1;
      if (a.district_nm > b.district_nm) return 1;
      return 0;
    })
    .map(({ district_id, district_nm }) => ({
      value: district_id,
      label: district_nm,
    }));

  const validate = ({ target }) => {
    const { value } = target;

    const option = options.find(({ label }) => label === value);

    if (!option || !option.value || option.value === '-') return;
    setDistrictLabel(value);

    setDistrictsArray(rawDistricts, option.value, hasCalendar);
    getCampaignActiveStatus(projectId, option.value);

    // reset the zone string to zone setup again
    setZoneStr('');

    if (
      !hasCalendar
      && hasWgw
    ) {
      history.push('/wgw');
      return;
    }

    history.push('/zone-setup');
  };

  return (
    <>
      {
      shouldSeeDistrictSelector && (
        <Container>
          <Text>
            {_('zone.to_get_waste_and_recycling_information_for_where_you_live_select_your_municipality')}
          </Text>
          <Input list="district_selection" placeholder={districtLabel || _('homePage.choose_your_area')} onChange={validate} />
          <DataList id="district_selection">
            {
              options.map(({ value, label }) => (
                <Option key={value} value={label} />
              ))
            }
          </DataList>
        </Container>
      )
    }
    </>
  );
};

export default connect(
  (store) => ({
    districtId: store.config.districtId,
    projectId: store.plugin.projectId,
    shouldSeeDistrictSelector: store.config.shouldSeeDistrictSelector,
    isMultiDistrict: store.config.isMultiDistrict,
    districts: Object.values(store.plugin.storeDistricts).length
      ? Object.values(store.plugin.storeDistricts)
      : [],
    rawDistricts: store.plugin.storeDistricts,
    webappConfig: store.config.webappConfig,
    districtLabel: store.config.districtLabel,
  }),
  (dispatch) => ({
    setZoneStr: (zoneStr) => dispatch(zoneSetup.setZoneStr(zoneStr)),
    setDistrictLabel: (districtLabel) => dispatch(configSetup.setDistrictLabel(districtLabel)),
    getCampaignActiveStatus: (project, district) => dispatch(campaignStatus(project, district))
  })
)(MultiDistrict);
